(function () {
  const content = document.querySelector('[data-article-content]');
  if (!content) return;

  const sidebar = document.querySelector('[data-article-sidebar]');
  const sidebarMode = sidebar?.dataset?.sidebarMode || '';
  const shouldTrackToc = sidebarMode !== 'products';
  const tocList = document.querySelector('[data-article-toc-list]');
  const emptyMsg = document.querySelector('[data-article-toc-empty]');
  const productCards = Array.from(document.querySelectorAll('.article-product-card[data-product-gid]'));

  // The theme header hides on scroll down and slides back in on scroll up, so sticky offsets follow it.
  const STICKY_GAP = 24;
  const header = document.querySelector('.section-header');
  const layoutRoot = content.closest('.article-template');

  const headerOffset = (shown) =>
    shown && header && header.classList.contains('shopify-section-header-sticky') ? header.offsetHeight : 0;

  const syncStickyTop = () => {
    const shown = Boolean(header) && !header.classList.contains('shopify-section-header-hidden');
    layoutRoot?.style.setProperty('--article-sticky-top', `${headerOffset(shown) + STICKY_GAP}px`);
  };

  if (header) {
    new MutationObserver(syncStickyTop).observe(header, { attributes: true, attributeFilter: ['class'] });
  }
  window.addEventListener('resize', syncStickyTop);
  syncStickyTop();

  // Scroll the sidebar's own list (not the page) so the active TOC link or perfume card stays in view.
  const keepInSidebarView = (el) => {
    if (!el || !sidebar) return;
    let box = el.parentElement;
    while (box && sidebar.contains(box)) {
      if (/(auto|scroll)/.test(getComputedStyle(box).overflowY) && box.scrollHeight > box.clientHeight + 1) break;
      box = box.parentElement;
    }
    if (!box || !sidebar.contains(box)) return;

    const boxRect = box.getBoundingClientRect();
    const elRect = el.getBoundingClientRect();
    const top = box.scrollTop + (elRect.top - boxRect.top) - (box.clientHeight - elRect.height) / 2;
    box.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  };

  const slugify = (text, used) => {
    const base =
      (text || '')
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-') || 'section';
    let slug = base;
    let n = 2;
    while (used.has(slug)) {
      slug = `${base}-${n++}`;
    }
    used.add(slug);
    return slug;
  };

  const headingMap = new Map();
  const used = new Set();

  // The FAQ title renders after the article body, so it is collected alongside the content headings.
  const faqTitle = document.querySelector('[data-article-faq-title]');
  const headings = Array.from(content.querySelectorAll('h2, h3, h4, h5, h6'));
  if (faqTitle) headings.push(faqTitle);

  headings.forEach((heading) => {
    const text = heading.textContent.trim();
    if (!text) return;

    if (!heading.id) heading.id = slugify(text, used);
    else used.add(heading.id);

    headingMap.set(heading.id, {
      id: heading.id,
      text,
      level: heading.tagName.toLowerCase(),
      el: heading,
    });
  });

  const tocItems = shouldTrackToc
    ? [...content.querySelectorAll('h2'), ...(faqTitle ? [faqTitle] : [])]
        .map((heading) => headingMap.get(heading.id))
        .filter(Boolean)
    : [];

  if (shouldTrackToc) {
    if (tocList && tocItems.length) {
      const frag = document.createDocumentFragment();
      tocItems.forEach((item) => {
        const li = document.createElement('li');
        li.className = `article-toc__item article-toc__item--${item.level}`;
        const a = document.createElement('a');
        a.className = 'article-toc__link';
        a.href = `#${item.id}`;
        a.textContent = item.text;
        a.dataset.tocTarget = item.id;
        li.appendChild(a);
        frag.appendChild(li);
      });
      tocList.appendChild(frag);
    } else if (tocList && emptyMsg) {
      emptyMsg.hidden = false;
    }
  }

  const links = shouldTrackToc && tocList ? Array.from(tocList.querySelectorAll('.article-toc__link')) : [];

  const setActiveToc = (id) => {
    links.forEach((link) => {
      link.classList.toggle('is-active', link.dataset.tocTarget === id);
    });
    keepInSidebarView(links.find((link) => link.dataset.tocTarget === id));
  };

  const parseProductGids = (heading) => {
    const raw = heading?.dataset?.productGids || heading?.dataset?.productGid || '';
    return raw
      .split(',')
      .map((value) => value.trim())
      .filter(Boolean);
  };

  const setActiveProducts = (heading) => {
    const gids = new Set(parseProductGids(heading));
    productCards.forEach((card) => {
      card.classList.toggle('is-active', gids.has(card.dataset.productGid));
    });
    keepInSidebarView(productCards.find((card) => card.classList.contains('is-active')));
  };

  const productItems = Array.from(content.querySelectorAll('h3[data-product-gid], h3[data-product-gids]'))
    .map((heading) => headingMap.get(heading.id))
    .filter(Boolean);

  const activateProductHeading = (id) => {
    const item = headingMap.get(id);
    if (!item) return;
    setActiveProducts(item.el);
  };

  if ('IntersectionObserver' in window) {
    if (shouldTrackToc && tocItems.length) {
      let activeTocId = tocItems[0].id;
      const visibleToc = new Map();

      const tocObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              visibleToc.set(entry.target.id, entry.intersectionRatio);
            } else {
              visibleToc.delete(entry.target.id);
            }
          });

          if (visibleToc.size === 0) return;

          let topId = null;
          let topPos = Infinity;
          visibleToc.forEach((_, id) => {
            const target = document.getElementById(id);
            if (!target) return;
            const rect = target.getBoundingClientRect();
            if (rect.top < topPos) {
              topPos = rect.top;
              topId = id;
            }
          });

          if (topId && topId !== activeTocId) {
            activeTocId = topId;
            setActiveToc(activeTocId);
          }
        },
        {
          rootMargin: '0px 0px -60% 0px',
          threshold: [0, 0.25, 0.5, 1],
        }
      );

      tocItems.forEach((item) => tocObserver.observe(item.el));
      setActiveToc(activeTocId);
    } else if (shouldTrackToc) {
      setActiveToc('');
    }

    if (productItems.length) {
      let activeProductId = null;
      const visibleProducts = new Map();
      const activationOffset = 120;
      const lastProductItem = productItems[productItems.length - 1];

      const productObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              visibleProducts.set(entry.target.id, entry.intersectionRatio);
            } else {
              visibleProducts.delete(entry.target.id);
            }
          });

          if (visibleProducts.size === 0) {
            let fallbackId = null;
            const lastItemRect = lastProductItem?.el?.getBoundingClientRect();
            const isPastLastProduct = lastItemRect ? lastItemRect.bottom <= activationOffset : false;

            if (!isPastLastProduct) {
              productItems.forEach((item) => {
                const rect = item.el.getBoundingClientRect();
                if (rect.top <= activationOffset) {
                  fallbackId = item.id;
                }
              });
            }

            if (fallbackId) {
              if (fallbackId !== activeProductId) {
                activeProductId = fallbackId;
                activateProductHeading(activeProductId);
              }
            } else if (activeProductId !== null) {
              activeProductId = null;
              setActiveProducts(null);
            }
            return;
          }

          let topId = null;
          let topPos = Infinity;
          visibleProducts.forEach((_, id) => {
            const target = document.getElementById(id);
            if (!target) return;
            const rect = target.getBoundingClientRect();
            if (rect.top < topPos) {
              topPos = rect.top;
              topId = id;
            }
          });

          if (topId && topId !== activeProductId) {
            activeProductId = topId;
            activateProductHeading(activeProductId);
          }
        },
        {
          rootMargin: '0px 0px -60% 0px',
          threshold: [0, 0.25, 0.5, 1],
        }
      );

      productItems.forEach((item) => productObserver.observe(item.el));
      setActiveProducts(null);
    } else {
      setActiveProducts(null);
    }
  } else {
    if (shouldTrackToc) setActiveToc(tocItems[0]?.id || '');
    setActiveProducts(null);
  }

  links.forEach((link) => {
    link.addEventListener('click', (e) => {
      const id = link.dataset.tocTarget;
      const target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      // Jumping up reveals the header, jumping down hides it, so land the heading just below where it will be.
      const targetY = target.getBoundingClientRect().top + window.scrollY;
      const top = targetY - headerOffset(targetY < window.scrollY) - STICKY_GAP;
      window.scrollTo({ top, behavior: 'smooth' });
      history.replaceState(null, '', `#${id}`);
      setActiveToc(id);
    });
  });
})();
